import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme: MantineTheme) => ({
  membershipAgreementPage: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "2rem",
  },

  signingView: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },

  header: {
    marginBottom: "2rem",
    borderBottom: `2px solid ${theme.colors.gray[2]}`,
    paddingBottom: "1rem",
  },

  heading: {
    fontSize: "28px",
    fontWeight: 700,
    marginBottom: "1rem",
    color: theme.colors.dark[7],
  },

  documentInfo: {
    display: "flex",
    gap: "2rem",
    fontSize: "14px",
    color: theme.colors.gray[7],
    "& p": {
      margin: 0,
    },
    "& strong": {
      fontWeight: 600,
      color: theme.colors.dark[6],
    },
  },

  instructions: {
    backgroundColor: theme.colors.gray[0],
    padding: "1.5rem",
    borderRadius: "8px",
    marginBottom: "2rem",
    "& p": {
      marginBottom: "1rem",
      fontSize: "14px",
      color: theme.colors.dark[6],
    },
    "& ul": {
      marginLeft: "1.5rem",
      "& li": {
        marginBottom: "0.5rem",
        fontSize: "14px",
        color: theme.colors.gray[7],
      },
    },
  },

  documentContainer: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    "& iframe": {
      width: "100%",
      height: "800px",
      border: "none",
    },
  },

  footerNote: {
    marginTop: "1rem",
    textAlign: "center",
    "& p": {
      fontSize: "12px",
      color: theme.colors.gray[6],
      fontStyle: "italic",
    },
  },

  signedView: {
    textAlign: "center",
    padding: "3rem",
  },

  successIcon: {
    width: "80px",
    height: "80px",
    color: theme.colors.green[6],
    margin: "0 auto 1rem",
  },

  signedMessage: {
    fontSize: "24px",
    fontWeight: 600,
    color: theme.colors.dark[7],
    marginBottom: "1rem",
  },

  signedDate: {
    fontSize: "14px",
    color: theme.colors.gray[6],
    marginBottom: "2rem",
  },

  buttonGroup: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginTop: "2rem",
  },

  errorView: {
    textAlign: "center",
    padding: "3rem",
  },

  errorIcon: {
    width: "80px",
    height: "80px",
    color: theme.colors.red[6],
    margin: "0 auto 1rem",
  },

  errorMessage: {
    fontSize: "18px",
    fontWeight: 500,
    color: theme.colors.red[7],
    marginBottom: "1rem",
  },

  errorDescription: {
    fontSize: "14px",
    color: theme.colors.gray[6],
    marginBottom: "2rem",
    maxWidth: "500px",
    margin: "0 auto 2rem",
  },

  loadingView: {
    textAlign: "center",
    padding: "4rem",
  },

  loadingMessage: {
    fontSize: "18px",
    fontWeight: 500,
    color: theme.colors.gray[7],
    marginTop: "1rem",
  },

  textMuted: {
    color: theme.colors.gray[6],
  },

  docviewer: {
    borderRadius: "8px",
    border: `1px solid ${theme.colors.gray[3]}`,
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
  },
  modalTitle: {
    fontWeight: 500,
    fontSize: "16px",
    padding: "7px",
  },
  modalHeader: {
    backgroundColor: "#ebeceb",
  },
  ulist: {
    fontSize: "12px",
  },
  headerText: {
    width: 361,
    height: 46,
    top: 95,
    left: 150,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "0em",
    textAlign: "left",
    fontStyle: "normal",
    marginBottom: "20px",
  },
  text: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "30px",
  },
}));
